import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.iterator";
import _extends from "@babel/runtime/helpers/esm/extends";

var _actions;

// Vendor Libs
import cloneDeep from 'lodash.clonedeep'; // Action Types

import { actionTypes } from '../action-types';
var initialState = {
  fieldErrors: {},
  values: {}
};

var getInitialState = function getInitialState(formKey, formConfig) {
  var _formConfig$formKey = formConfig[formKey];
  _formConfig$formKey = _formConfig$formKey === void 0 ? {} : _formConfig$formKey;
  var _formConfig$formKey$f = _formConfig$formKey.fields,
      fields = _formConfig$formKey$f === void 0 ? {} : _formConfig$formKey$f;
  var defaultValues = Object.keys(fields).filter(function (k) {
    return 'default' in fields[k];
  }).reduce(function (target, k) {
    var _extends2;

    return _extends({}, target, (_extends2 = {}, _extends2[k] = fields[k]["default"], _extends2));
  }, {});
  return _extends({}, cloneDeep(initialState), {
    values: _extends({}, cloneDeep(initialState.values), {}, defaultValues)
  });
};

var actions = (_actions = {}, _actions[actionTypes.FORM_REGISTER] = function (state, _ref, formConfig) {
  var _extends3;

  var formKey = _ref.payload.formKey;
  return !state[formKey] ? _extends({}, cloneDeep(state), (_extends3 = {}, _extends3[formKey] = getInitialState(formKey, formConfig), _extends3)) : state;
}, _actions[actionTypes.FORM_UNREGISTER] = function (state, _ref2) {
  var _extends4;

  var formKey = _ref2.payload.formKey;
  return _extends({}, cloneDeep(state), (_extends4 = {}, _extends4[formKey] = undefined, _extends4));
}, _actions[actionTypes.FORM_RESET] = function (state, _ref3, formConfig) {
  var _extends5;

  var formKey = _ref3.payload.formKey;
  return formKey ? _extends({}, cloneDeep(state), (_extends5 = {}, _extends5[formKey] = getInitialState(formKey, formConfig), _extends5)) : {};
}, _actions[actionTypes.FORM_SET_FIELD_VALUE] = function (state, _ref4) {
  var _extends6, _extends7;

  var _ref4$payload = _ref4.payload,
      formKey = _ref4$payload.formKey,
      fieldName = _ref4$payload.fieldName,
      value = _ref4$payload.value;
  return _extends({}, cloneDeep(state), (_extends7 = {}, _extends7[formKey] = _extends({}, cloneDeep(state[formKey]), {
    values: _extends({}, cloneDeep(state[formKey].values), (_extends6 = {}, _extends6[fieldName] = value !== '' ? value : undefined, _extends6))
  }), _extends7));
}, _actions[actionTypes.FORM_SET_FIELD_VALUES] = function (state, _ref5) {
  var _extends8;

  var _ref5$payload = _ref5.payload,
      formKey = _ref5$payload.formKey,
      values = _ref5$payload.values,
      resetValues = _ref5$payload.resetValues;
  return _extends({}, cloneDeep(state), (_extends8 = {}, _extends8[formKey] = _extends({}, cloneDeep(state[formKey]), {
    values: resetValues ? values : _extends({}, cloneDeep(state[formKey].values), {}, values)
  }), _extends8));
}, _actions[actionTypes.FORM_CLEAR_FIELD_VALUE] = function (state, _ref6) {
  var _extends9, _extends10;

  var _ref6$payload = _ref6.payload,
      formKey = _ref6$payload.formKey,
      fieldName = _ref6$payload.fieldName;
  return _extends({}, cloneDeep(state), (_extends10 = {}, _extends10[formKey] = _extends({}, cloneDeep(state[formKey]), {
    values: _extends({}, cloneDeep(state[formKey].values), (_extends9 = {}, _extends9[fieldName] = undefined, _extends9))
  }), _extends10));
}, _actions[actionTypes.FORM_SET_FIELD_ERRORS] = function (state, _ref7) {
  var _extends11, _extends12;

  var _ref7$payload = _ref7.payload,
      formKey = _ref7$payload.formKey,
      fieldName = _ref7$payload.fieldName,
      errors = _ref7$payload.errors;
  return _extends({}, cloneDeep(state), (_extends12 = {}, _extends12[formKey] = _extends({}, cloneDeep(state[formKey]), {
    fieldErrors: _extends({}, cloneDeep(state[formKey].fieldErrors), (_extends11 = {}, _extends11[fieldName] = errors, _extends11))
  }), _extends12));
}, _actions[actionTypes.FORM_CLEAR_FIELD_ERRORS] = function (state, _ref8) {
  var _extends13, _extends14;

  var _ref8$payload = _ref8.payload,
      formKey = _ref8$payload.formKey,
      fieldName = _ref8$payload.fieldName;
  return _extends({}, cloneDeep(state), (_extends14 = {}, _extends14[formKey] = _extends({}, cloneDeep(state[formKey]), {
    fieldErrors: _extends({}, cloneDeep(state[formKey].fieldErrors), (_extends13 = {}, _extends13[fieldName] = undefined, _extends13))
  }), _extends14));
}, _actions);
export var getFormReducer = function getFormReducer(_temp) {
  var _ref9 = _temp === void 0 ? {} : _temp,
      formConfig = _ref9.formConfig;

  return function (state, action) {
    if (state === void 0) {
      state = {};
    }

    return actions[action.type] ? actions[action.type](state, action, formConfig) : state;
  };
};